import type ICustomCategoriesMessages from '.';

const customCategoriesMessages: ICustomCategoriesMessages = {
	customCategoryDescription: 'Category',
	customCategoryHasMasterItems:
		'Cannot delete. This custom category is associated to master items.',
	customCategoryIsDefault:
		'Cannot delete. This custom category is a default custom category.',
	customCategoryIsDefaultAndHasMasterItems:
		'Cannot delete. This custom category is default and is associated to master items.',
	customCategoryTableTitle: 'Custom Categories for {customerName}',
	delete: 'Delete',
	deleteModalBody:
		'You cannot undo this action. Are you sure you want to delete this custom category?',
	deleteModalTitle: 'Deleting Custom Category "{customCategoryDescription}"',
	deleteSuccessToastMessage: 'Custom category deleted.',
	deleteSuccessToastTitle: 'Success!',
	description: 'Description',

	descriptionValidationError:
		'Description must be alpha-numeric and between 1 and 30 characters in length. The only special characters allowed are space, -, &, _, and /.',
	edit: 'Edit',
	editCustomCategory: 'Edit Custom Category',
	editSaveSuccessToastMessage: 'Custom Category saved.',
	editSaveSuccessToastTitle: 'Success!',
	isDefault: 'Is Default',
	manageCustomCategories: 'Manage Custom Categories',
	masterOrderGuides: 'Master Order Guides',
	metaProductCount: 'Master Item Count',
	newCustomCategory: 'New Custom Category',
	newSaveSuccessToastMessage: 'Custom Category created.',
	newSaveSuccessToastTitle: 'Success!',
	pendingDeleteCannotDelete:
		'Cannot delete. This custom category is currently being deleted.',
	pendingDeleteCannotEdit:
		'Cannot edit. This custom category is currently being deleted.',
	pendingDeleteCannotEditOrDelete:
		'This custom category is currently being deleted.',
	save: 'Save',
	sequenceNumber: 'Sequence Number',
	sequenceNumberForColumn: 'Sequence\u00a0#',
	sequenceNumberValidationError:
		'Sequence Number must numeric and between 1 and 3 characters in length.',
	setAsDefault: 'Set as Default',
	navigationWarning:
		'You have unsaved changes. Are you sure you want to leave?',
};

export default customCategoriesMessages;
